import { render } from "./collaborator.vue?vue&type=template&id=7ac3e56b"
import script from "./collaborator.vue?vue&type=script&lang=js"
export * from "./collaborator.vue?vue&type=script&lang=js"

import "./collaborator.vue?vue&type=style&index=0&id=7ac3e56b&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__